var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1513_3740",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 85,
    height: 85
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1513_3740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5404 58.7913L62.5091 33.8226L57.5508 28.8643L37.5404 48.8747L27.4466 38.7809L22.4883 43.7393L37.5404 58.7913ZM42.4987 77.9163C37.5994 77.9163 32.9952 76.9867 28.6862 75.1273C24.3772 73.2679 20.6289 70.7445 17.4414 67.557C14.2539 64.3695 11.7305 60.6212 9.87109 56.3122C8.01172 52.0032 7.08203 47.399 7.08203 42.4997C7.08203 37.6004 8.01172 32.9962 9.87109 28.6872C11.7305 24.3781 14.2539 20.6299 17.4414 17.4424C20.6289 14.2549 24.3772 11.7314 28.6862 9.87207C32.9952 8.0127 37.5994 7.08301 42.4987 7.08301C47.398 7.08301 52.0022 8.0127 56.3112 9.87207C60.6202 11.7314 64.3685 14.2549 67.556 17.4424C70.7435 20.6299 73.2669 24.3781 75.1263 28.6872C76.9857 32.9962 77.9154 37.6004 77.9154 42.4997C77.9154 47.399 76.9857 52.0032 75.1263 56.3122C73.2669 60.6212 70.7435 64.3695 67.556 67.557C64.3685 70.7445 60.6202 73.2679 56.3112 75.1273C52.0022 76.9867 47.398 77.9163 42.4987 77.9163ZM42.4987 70.833C50.4084 70.833 57.1081 68.0882 62.5977 62.5986C68.0872 57.1091 70.832 50.4094 70.832 42.4997C70.832 34.59 68.0872 27.8903 62.5977 22.4007C57.1081 16.9111 50.4084 14.1663 42.4987 14.1663C34.589 14.1663 27.8893 16.9111 22.3997 22.4007C16.9102 27.8903 14.1654 34.59 14.1654 42.4997C14.1654 50.4094 16.9102 57.1091 22.3997 62.5986C27.8893 68.0882 34.589 70.833 42.4987 70.833Z",
    fill: "#348BDC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.d38acf594aef570906d10f1ffdaecac6.svg";
export { ForwardRef as ReactComponent };